import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Company/CompanyName';

export default function CompanyName() {
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <>
      <Stepper
        title="Awesome! What's the name of your store?"
        headerWidth={800}
        contentWidth={800}
        hideContent={!(products && business)}
      >
        <PageLayout />
      </Stepper>
    </>
  );
}
